import React from 'react';
import { Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

type Props = {
  utmData?: Record<string, unknown> | null;
};

export const UtmBlock = ({ utmData }: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const isEmpty = !utmData || Object.keys(utmData).length === 0;

  return (
    <Grid container gap={1} flexDirection="column" borderRadius="8px" border="1px solid" borderColor="divider" p={1.5}>
      <Typography fontWeight={700}>{t('calendar.edit_order.utm')}</Typography>
      {isEmpty ? (
        <Typography variant="body2" color="text.secondary">
          {t('calendar.edit_order.no_utm')}
        </Typography>
      ) : (
        Object.entries(utmData).map(([key, value]) => (
          <Grid container key={key} alignItems="center" wrap="nowrap">
            <Typography>{`${key.split('_').join(' ')}: `}</Typography>
            <Typography
              sx={{
                maxWidth: isSmallScreen ? '150px' : '300px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                cursor: 'copy',
              }}
              onClick={() => navigator.clipboard.writeText(String(value))}
              title={`${String(value)} (click to copy)`}>
              {String(value)}
            </Typography>
          </Grid>
        ))
      )}
    </Grid>
  );
};
